import { AutoMap } from "@automapper/classes";
import { createMap, forMember, mapFrom } from "@automapper/core";
import { mapper } from "src/app/infrastructure/infrastructure-services/common/mapper";

export class PaymentChecks{
   

 @AutoMap()    dueDate: string | Date="";
 @AutoMap()    checkNumber: string="";
 @AutoMap()    bankCode: string="";
 @AutoMap()    bankName: string="";
 @AutoMap()    branch: string="";
 @AutoMap()    accounttNum: string="";
 @AutoMap()    details:string="";
 @AutoMap()    checkSum: number=0;
 @AutoMap()    currency: string="";
 @AutoMap()    countryCode: string="";
 @AutoMap()    countryName: string="";
 @AutoMap()    checkAccount: string="";
 @AutoMap()    checkAccountName: string="";

    constructor() {
        createMap(mapper, PaymentChecks, PaymentChecksSAP,
          forMember(
            (destination) => destination.CheckNumber,
            mapFrom((source) => source.checkNumber)
        ),
        forMember(
            (destination) => destination.BankCode,
            mapFrom((source) => source.bankCode)
        ),
        forMember(
            (destination) => destination.AccounttNum,
            mapFrom((source) => source.accounttNum)
        ),
        forMember(
            (destination) => destination.DueDate,
            mapFrom((source) => source.dueDate)
        ),
        forMember(
            (destination) => destination.CheckSum,
            mapFrom((source) => source.checkSum)
        ),
        forMember(
            (destination) => destination.CountryCode,
            mapFrom((source) => source.countryCode)
        )
    );
     }
}
export class PaymentChecksSAP{
 @AutoMap()   CheckNumber: string="";
 @AutoMap()  BankCode: string="";
 @AutoMap()   AccounttNum: string="";
 @AutoMap()  DueDate: string | Date=""
 @AutoMap()   CheckSum:number=0;
 @AutoMap()   CountryCode: string="";

 constructor() {
    createMap(mapper, PaymentChecks, PaymentChecksSAP,
      forMember(
        (destination) => destination.CheckNumber,
        mapFrom((source) => source.checkNumber)
    ),
    forMember(
        (destination) => destination.BankCode,
        mapFrom((source) => source.bankCode)
    ),
    forMember(
        (destination) => destination.AccounttNum,
        mapFrom((source) => source.accounttNum)
    ),
    forMember(
        (destination) => destination.DueDate,
        mapFrom((source) => source.dueDate)
    ),
    forMember(
        (destination) => destination.CheckSum,
        mapFrom((source) => source.checkSum)
    ),
    forMember(
        (destination) => destination.CountryCode,
        mapFrom((source) => source.countryCode)
    )
);
 }
}

export class PaymentCreditCards{
    @AutoMap() creditCard: number=0;
    @AutoMap()  creditAcct: string="";
     @AutoMap()  creditCardNumber: number=0;
     @AutoMap()  cardValidUntil: string ="";
     @AutoMap()  ownerIdNum: string="";
     @AutoMap()  ownerPhone: string="";
     @AutoMap()  creditSum: number=0;
     @AutoMap() voucherNum: string="";
     @AutoMap() numOfPayments:number=0;
    @AutoMap() additionalPaymentSum:number=0;
    @AutoMap() firstPaymentSum:number=0;
    @AutoMap() paymentMethodCode: number=0;
     constructor() {
        createMap(mapper, PaymentCreditCards, PaymentCreditCardsSAP,
          forMember(
            (destination) => destination.CreditCard,
            mapFrom((source) => source.creditCard)
        ),
        forMember(
            (destination) => destination.CreditAcct,
            mapFrom((source) => source.creditAcct)
        ),
        forMember(
            (destination) => destination.CreditCardNumber,
            mapFrom((source) => source.creditCardNumber)
        ),
        forMember(
            (destination) => destination.CardValidUntil,
            mapFrom((source) => source.cardValidUntil)
        ),
        forMember(
            (destination) => destination.CreditSum,
            mapFrom((source) => source.creditSum)
        ),
        forMember(
            (destination) => destination.VoucherNum,
            mapFrom((source) => source.voucherNum)
        ),
        forMember(
            (destination) => destination.OwnerIdNum,
            mapFrom((source) => source.ownerIdNum)
        ),
        forMember(
            (destination) => destination.OwnerPhone,
            mapFrom((source) => source.ownerPhone)
        ),
        forMember(
            (destination) => destination.VoucherNum,
            mapFrom((source) => source.voucherNum)
        ),
        forMember(
            (destination) => destination.FirstPaymentSum,
            mapFrom((source) => source.firstPaymentSum)
        ),
        forMember(
            (destination) => destination.AdditionalPaymentSum,
            mapFrom((source) => source.additionalPaymentSum)
        ),
        forMember(
            (destination) => destination.NumOfPayments,
            mapFrom((source) => source.numOfPayments)
        ),
        forMember(
            (destination) => destination.PaymentMethodCode,
            mapFrom((source) => source.paymentMethodCode)
        ),
    );
}
}
export class PaymentCreditCardsSAP{
   @AutoMap() CreditCard: number=0;
   @AutoMap()  CreditAcct: string="";
    @AutoMap()  CreditCardNumber: number=0;
    @AutoMap()  CardValidUntil: string ="";
    @AutoMap()  OwnerIdNum: string="";
    @AutoMap()  OwnerPhone: string="";
    @AutoMap()  CreditSum: number=0;
    @AutoMap() VoucherNum: string="";
    @AutoMap() NumOfPayments:number=0;
    @AutoMap() AdditionalPaymentSum:number=0;
    @AutoMap() FirstPaymentSum:number=0;
    @AutoMap() PaymentMethodCode:number=0;

    constructor() {
        createMap(mapper, PaymentCreditCards, PaymentCreditCardsSAP,
          forMember(
            (destination) => destination.CreditCard,
            mapFrom((source) => source.creditCard)
        ),
        forMember(
            (destination) => destination.CreditAcct,
            mapFrom((source) => source.creditAcct)
        ),
        forMember(
            (destination) => destination.CreditCardNumber,
            mapFrom((source) => source.creditCardNumber)
        ),
        forMember(
            (destination) => destination.CardValidUntil,
            mapFrom((source) => source.cardValidUntil)
        ),
        forMember(
            (destination) => destination.CreditSum,
            mapFrom((source) => source.creditSum)
        ),
        forMember(
            (destination) => destination.VoucherNum,
            mapFrom((source) => source.voucherNum)
        ),
        forMember(
            (destination) => destination.FirstPaymentSum,
            mapFrom((source) => source.firstPaymentSum)
        ),
        forMember(
            (destination) => destination.AdditionalPaymentSum,
            mapFrom((source) => source.additionalPaymentSum)
        ),
        forMember(
            (destination) => destination.NumOfPayments,
            mapFrom((source) => source.numOfPayments)
        ),
        forMember(
            (destination) => destination.PaymentMethodCode,
            mapFrom((source) => source.paymentMethodCode)
        ),
    );
     }


}